import type { AnalyticsService } from './types';

export function createPostHogAnalyticsService(): AnalyticsService {
  return {
    initialize: async () => {
      // PostHog is initialized in instrumentation-client.ts for early loading.
      // This is a no-op fallback — posthog.init() is safe to call multiple times.
      const posthog = (await import('posthog-js')).default;
      const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;

      if (key && !posthog.__loaded) {
        posthog.init(key, {
          api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || '/p',
          person_profiles: 'identified_only',
          capture_pageview: false,
          capture_pageleave: true,
        });
      }
    },
    trackEvent: async (eventName, eventProperties) => {
      const posthog = (await import('posthog-js')).default;
      posthog.capture(eventName, eventProperties);
    },
    trackPageView: async (path) => {
      const posthog = (await import('posthog-js')).default;
      posthog.capture('$pageview', { $current_url: path });
    },
    identify: async (userId, traits) => {
      const posthog = (await import('posthog-js')).default;
      posthog.identify(userId, traits);
    },
  };
}
